import React from 'react';
import PropTypes from 'prop-types';

const SVG = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" className={props.className}>
    <g fill="none" fillRule="evenodd" stroke="#B5B4B8" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" transform="translate(1 1)">
      <path d="M11 11.17a4.977 4.977 0 0 0-2.5-.67h-3a5 5 0 0 0-5 5h7" />
      <circle cx="7" cy="4" r="3.5" />
      <path d="M9.5 13.5l2 2 4-4" />
    </g>
  </svg>
);

SVG.propTypes = {
  className: PropTypes.string,
};

export default SVG;
